import { RootState } from 'store';
import { useSelector } from 'react-redux';
import {
  checkIsLoading,
  checkIsLoadingDone
} from 'common/utils/checkLoading';

import { DRIVERS_STATE } from '../../constants';

export const useDriverFuelAssignment = () => {
  const driverFuelAssignment = useSelector((state: RootState) => state[DRIVERS_STATE].fuelAssignment.data);
  return driverFuelAssignment;
};

const useDriverFuelAssignmentLoadingStatus = () => {
  const driverFuelAssignmentLoadingStatus = useSelector((state: RootState) => state[DRIVERS_STATE].fuelAssignment.loadingStatus);
  return driverFuelAssignmentLoadingStatus;
};

export const useIsDriverFuelAssignmentLoading = () => {
  const driverFuelAssignmentLoadingStatus = useDriverFuelAssignmentLoadingStatus();
  return checkIsLoading(driverFuelAssignmentLoadingStatus);
};

export const useAddingDriverFuelAssignmentLoadingStatus = () => {
  const addingDriverFuelAssignmentLoadingStatus = useSelector((state: RootState) => state[DRIVERS_STATE].fuelAssignment.addingStatus);
  return addingDriverFuelAssignmentLoadingStatus;
};

export const useIsAddingDriverFuelAssignmentLoading = () => {
  const isAddingDriverFuelAssignmentLoading = useAddingDriverFuelAssignmentLoadingStatus();
  return checkIsLoading(isAddingDriverFuelAssignmentLoading);
};

export const useIsAddingDriverFuelAssignmentDone = () => {
  const isAddingDriverFuelAssignmentLoading = useAddingDriverFuelAssignmentLoadingStatus();
  return checkIsLoadingDone(isAddingDriverFuelAssignmentLoading);
};

export const useDeletingDriverFuelAssignmentLoadingStatus = () => {
  const deletingStatusDriverFuelAssignmentLoadingStatus = useSelector((state: RootState) => state[DRIVERS_STATE].fuelAssignment.deletingStatus);
  return deletingStatusDriverFuelAssignmentLoadingStatus;
};

export const useIsDeletingDriverFuelAssignmentLoading = () => {
  const deletingDriverFuelAssignmentLoadingStatus = useDeletingDriverFuelAssignmentLoadingStatus();
  return checkIsLoading(deletingDriverFuelAssignmentLoadingStatus);
}

export const useIsDeletingDriverFuelAssignmentDone = () => {
  const deletingDriverFuelAssignmentLoadingStatus = useDeletingDriverFuelAssignmentLoadingStatus();
  return checkIsLoadingDone(deletingDriverFuelAssignmentLoadingStatus);
}
